// src/App.jsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

// Public Pages
import Home from "./pages/Home";
import Features from "./pages/Features";
import Solutions from "./pages/Solutions";
import Pricing from "./pages/Pricing";
import Demo from "./pages/Demo";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Roadmap from "./pages/Roadmap";
import Videos from "./pages/Videos";
import GettingStarted from "./pages/GettingStarted";
import AdminFeatures from "./pages/AdminFeatures";
import Unsubscribe from "./pages/Unsubscribe";
import UnsubscribeConfirmed from "./pages/UnsubscribeConfirmed";
import PrivacyPolicy from "./pages/PrivacyPolicy";

// Admin Pages (Protected)
import AdminDashboard from "./pages/AdminDashboard";
import AdminManagement from "./pages/AdminManagement";
import TestPage from "./pages/TestPage";
import EmailAds from "./pages/EmailAds";
import EmailMarketing from "./pages/EmailMarketing";

// Placeholder component for pages under development
const ComingSoon = ({ title }) => (
  <Layout>
    <div className="container py-5">
      <h1>{title}</h1>
      <p>This page is coming soon...</p>
      <a href="/admin-dashboard" className="btn btn-primary">
        Back to Dashboard
      </a>
    </div>
  </Layout>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route
            path="/unsubscribe-confirmed"
            element={<UnsubscribeConfirmed />}
          />
          <Route path="/privacy" element={<PrivacyPolicy />} />

          {/* Training pages */}
          <Route path="/gettingstarted" element={<GettingStarted />} />
          <Route path="/adminfeatures" element={<AdminFeatures />} />

          {/* Friendly redirects for alternate slugs */}
          <Route
            path="/getting-started"
            element={<Navigate to="/gettingstarted" replace />}
          />
          <Route
            path="/admin-features"
            element={<Navigate to="/adminfeatures" replace />}
          />

          {/* Protected Admin Routes */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-management"
            element={
              <ProtectedRoute>
                <AdminManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-marketing"
            element={
              <ProtectedRoute>
                <EmailMarketing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-ads"
            element={
              <ProtectedRoute>
                <EmailAds />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testpage"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/test-page"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testing123"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />

          {/* Future Protected Admin Routes (placeholders) */}
          <Route
            path="/admin-settings"
            element={
              <ProtectedRoute>
                <ComingSoon title="Admin Settings" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <ComingSoon title="Analytics" />
              </ProtectedRoute>
            }
          />

          {/* Catch-all to avoid blank screens */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
